import {
  Col,
  ConfigProvider,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
} from "antd";
import moment from "moment";
import React from "react";
import { FaRegCalendarXmark } from "react-icons/fa6";

interface Props {
  form: any;
  options: any;
  dateFormat: string;
  isParTranche: boolean;
  trancheOptions: any;
}
const customizeRenderEmpty = () => (
  <div style={{ textAlign: "center" }}>
    <FaRegCalendarXmark style={{ fontSize: 20 }} />
    <p>Aucun projet affecté pour le moment...</p>
  </div>
);
export const InformationVisiteStep: React.FC<Props> = ({
  form,
  options,
  dateFormat,
  isParTranche,
  trancheOptions,
}) => {
  function disabledDate(current: any) {
    return current && current < moment().subtract(7, "days").startOf("day");
  }

  return (
    <Row style={{ width: "100%" }} justify={"center"}>
      <Col xs={24} sm={24} md={12} lg={12}>
        <Form.Item
          name="date_visite"
          label="Date de Visite"
          rules={[
            {
              required: true,
              message: "Veuillez sélectionner la date de visite !",
            },
          ]}
        >
          <DatePicker
            //disabledDate={disabledDate}
            style={{ width: "100%" }}
            format={dateFormat}
          />
        </Form.Item>
        <Form.Item
          name="utilisateur"
          label="Visiteur"
          rules={[
            {
              required: true,
              message: "Veuillez saisir le nom du projet !",
            },
          ]}
          style={{ display: "none" }}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="nom_visiteur"
          label="Visiteur"
          rules={[
            {
              required: true,
              message: "",
            },
          ]}
        >
          <Input disabled />
        </Form.Item>
        <ConfigProvider renderEmpty={customizeRenderEmpty}>
          <Form.Item
            name="fk_nom_du_projet"
            label="Projet"
            rules={[
              {
                required: true,
                message: "Veuillez sélectionner un projet !",
              },
            ]}
          >
            <Select optionFilterProp="label" showSearch placeholder="Sélectionnez un projet" options={options} />
          </Form.Item>
        </ConfigProvider>
        {isParTranche && (
          <Form.Item
            name="fk_tranche"
            label="Tranche"
            rules={[
              {
                required: true,
                message: "Veuillez sélectionner une tranche !",
              },
            ]}
          >
            <Select
              placeholder="Sélectionnez une tranche"
              options={trancheOptions}
            />
          </Form.Item>
        )}

        <Form.Item
          name="bureau_de_vente"
          label="Bureau de Vente"
          rules={[
            {
              required: true,
              message: "Veuillez sélectionner le bureau de vente !",
            },
          ]}
        >
          <Select>
            <Select.Option value="disponible">Disponible</Select.Option>
            <Select.Option value="indisponible">Indisponible</Select.Option>
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default InformationVisiteStep;
